export default {
    nl: {
        intro: {
            subtitle: 'UX research',
            title: 'Detective spelen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/ux-research/hero.jpg',
        },
        type: 'UX research',
        title: 'UX research: Gebruikersonderzoek voor optimaal ontwerp',
        description:
            'Met UX research begrijp en optimaliseer je gebruikerservaring. Onze methodes garanderen tevredenheid, kostenbesparing & loyale klanten.',
        content: [
            {
                type: 'text',
                title: 'UX research',
                content:
                    'Een vaak onderschat aspect van het ontwerpproces is UX research ofwel gebruikersonderzoek. Er is namelijk niets vervelender dan een product dat niet aansluit op de wensen en behoeften van je eindgebruikers. Gebruikersonderzoek draait om het gedetailleerd begrijpen van je gebruikers: hun gedrag, behoeften en uitdagingen. Met behulp van verschillende onderzoeksmethodes zoals customer journeys, A/B testing, usability tests, focusgroepen, interviews, observaties en enquêtes verzamelen we waardevolle inzichten. Deze inzichten geven ons de context en het perspectief om weloverwogen ontwerpkeuzes te maken, resulterend in producten die écht voor de eindgebruiker werken.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/research.webp',
                ],
                imageWidth: 817,
            },
            {
                type: 'text',
                title: 'Ons onderzoeksproces',
                content: `
                    Wij vinden het belangrijk om in elke fase van het ontwerpproces onderzoek te doen, van vroege interviews en veldstudies tot het testen van prototypen en het monitoren na de lancering van het eindproduct. Onze UX researcher fungeert daarbij als schakel tussen jouw eindgebruiker en onze productteams.
                    <br><br>
                    Tijdens de creatie van een nieuwe applicatie werken we aan de hand van Design Sprints. Hier testen en valideren we altijd de uitkomsten met de eindgebruikers van jouw product. Zo heb je al binnen een week een getoetst ontwerp dat klikt met je doelgroep.
                    <br><br>
                    Natuurlijk gaat UX research verder dan alleen het ontwerp van nieuwe applicaties. Het is eveneens de sleutel tot het verbeteren van bestaande producten. Wanneer je een specifieke hulp- of onderzoeksvraag hebt, staan we voor je klaar.
                `,
            },
            {
                type: 'list',
                title: 'De voordelen van UX research',
                items: [
                    'Directe feedback: in plaats van te gokken wat gebruikers willen, krijg je concrete data rechtstreeks van hen.',
                    'Kostenbesparing op lange termijn: fouten vroegtijdig opmerken betekent minder dure wijzigingen later in het proces.',
                    'Verhoogde gebruikerstevredenheid: een product dat op echte gebruikersbehoeften inspeelt, zorgt voor tevreden en loyale klanten.',
                ],
            },
            {
                type: 'case',
                case: 'nines',
            },
        ],
        related_services: ['ui-ux-design', 'strategy-session', 'design-sprint'],
        contact: {
            title: '',
            employee: 'michiel',
        },
    },
    en: {},
};
